import ACTIONS from '../actionTypes/contract';
import { checkAgreementAcceptanceStatus } from '../../helpers/AgreementAcceptanceResolver';
import customerAccessRoles from '../../constants/customerAccessRoles';

const initialState = {
  contracts: [],
  selectedContractId: '',
  customerAccessRoleOfSelectedContract: customerAccessRoles.SUPPORT,
  selectedContract: null,
  agreementsAccepted: false,
  agreements: [],
  loadingContracts: false,
  loadingAgreements: false,
  errorContracts: false,
  errorAgreements: false,
  updatingAgreement: false,
  errorUpdateAgreement: false,
  updatingAgreementId: '',
  creatingContract:false,
  errorCreatingContract:false,
  lastUpdatedTime: new Date().toISOString()
}

export default function contract(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.CLEAR_CONTRACT_INFO: {
      return {
        ...initialState,
      };
    }
    case ACTIONS.UPDATE_USER_CONTRACTS:
      return {
        ...state,
        loadingContracts: true,
        errorContracts: false,
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.UPDATE_USER_CONTRACTS_SUCCESS:
      return {
        ...state,
        contracts: [...action.payload],
        loadingContracts: false,
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.UPDATE_USER_CONTRACTS_FAILED:
      return {
        ...state,
        loadingContracts: false,
        errorContracts: true,
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.UPDATE_AGREEMENTS_LIST:
      return {
        ...state,
        loadingAgreements: true,
        errorAgreements: false,
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.UPDATE_AGREEMENTS_LIST_SUCCESS:
      return {
        ...state,
        agreements: [...action.payload.data],
        loadingAgreements: false,
        updatingAgreement: false,
        errorUpdateAgreement: false,
        agreementsAccepted: checkAgreementAcceptanceStatus([...action.payload.data], action.payload.globalIdentity, action.payload.contractId),
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.UPDATE_AGREEMENTS_LIST_SUCCESS_SILENTLY:
      return {
        ...state,
        agreements: [...action.payload.data],
        updatingAgreement: false,
        errorUpdateAgreement: false,
        agreementsAccepted: checkAgreementAcceptanceStatus([...action.payload.data], action.payload.globalIdentity, action.payload.contractId),
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.UPDATE_AGREEMENTS_LIST_FAILED:
      return {
        ...state,
        loadingAgreements: false,
        errorAgreements: true,
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.UPDATE_SELECTED_CONTRACT:
      return {
        ...state,
        selectedContractId: action.payload,
        selectedContract: state.contracts.find(e => e.id == action.payload),
        customerAccessRoleOfSelectedContract: state.contracts.find(e => e.id == action.payload)?.customer?.managers.find(k => k?.user?.identity == action.globalIdentity)?.accessRole || customerAccessRoles.SUPPORT,
        loadingAgreements: true,
        agreementsAccepted: false,
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.ACCEPT_AGREEMENT:
      return {
        ...state,
        updatingAgreement: true,
        errorUpdateAgreement: false,
        updatingAgreementId: action.payload,
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.ACCEPT_AGREEMENT_SUCCESS:
      return {
        ...state,
        updatingAgreement: false,
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.ACCEPT_AGREEMENT_FAILED:
      return {
        ...state,
        updatingAgreement: false,
        errorUpdateAgreement: true,
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.UPDATE_CONTRACT_LIST_SILENTLY:
      return {
        ...state,
        contracts: [...action.payload.contracts],
        selectedContract: action.payload.selectedContract,
        lastUpdatedTime: new Date().toISOString(),
      };
    case ACTIONS.CREATE_CONTRACT:
      return {
        ...state,
        creatingContract: true,
        errorCreatingContract: false
      };
    case ACTIONS.CREATE_CONTRACT_SUCCESS:
      return {
        ...state,
        creatingContract: false,
        errorCreatingContract: false,
      };
    case ACTIONS.CREATE_CONTRACT_FAILED:
      return {
        ...state,
        creatingContract: false,
        errorCreatingContract: true,
      };
    default:
      return state;
  }
}